import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import dayjs from "../../utils/dayjs";

const formatDate = (value: any): string => {
  if (value == null || value === "") return "";
  const d = dayjs.utc(value);
  return d.isValid() ? d.format("MM/DD/YY") : String(value);
};

const dateColumnFormatter = (value: any) => formatDate(value);

export const SkuCutoversContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "sku_transition_summary",
        transformId: "sku_transition_summary",
        folder: "outputs",
        title: "SKU Cutovers",
        dateHierarchyColumnFilter: null,
        excludedSegmentationsFilter: [],
        measureColumnFilter: null,
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.FilterBy,
          PivotControl.Download,
        ],
        paramsToTransformArgs,
        tableType: "flat",
        columnHeaderMap: {
          planned_cutover_date: "planned cutover date",
          projected_runout_date: "projected runout date",
          effective_cutover_date: "effective cutover date",
          starting_committed_supply: "starting committed supply",
          forecasted_demand_before_cutover: "forecasted demand before cutover",
          supply_remaining_at_cutover: "supply remaining at cutover",
        },
        columnFormatters: {
          planned_cutover_date: dateColumnFormatter,
          projected_runout_date: dateColumnFormatter,
          effective_cutover_date: dateColumnFormatter,
        },
      }}
      defaultConfig={defaultConfig}
    />
  );
};
